import { useContext } from "react"
import { ContratoAplicativoContext } from "./ContratoAplicativoContext"

export function useContratoAplicativoContext() {
    return useContext(ContratoAplicativoContext)
}
